import { render, staticRenderFns } from "./BooleanFilter.vue?vue&type=template&id=4f63f7c5&scoped=true"
import script from "./BooleanFilter.vue?vue&type=script&lang=ts"
export * from "./BooleanFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63f7c5",
  null
  
)

export default component.exports